import routeUrls from './route-urls';

const DocumentTypes = {
  SENT: 'SENT',
  RECEIVED: 'RECEIVED',
  PROCESSING: 'PROCESSING',
  FILTERS: 'FILTERS',
  ACTION_REQUIRED: 'ACTION_REQUIRED',
  EXPIRED: 'EXPIRED',
  COMPLETED: 'COMPLETED',
  EXPIRING_SOON: 'EXPIRING_SOON',
  WAITING_FOR_OTHERS: 'WAITING_FOR_OTHERS',
  FAILED: 'FAILED',
  ALL: 'ALL',
  CC: 'CC',
  DRAFTS: 'DRAFTS',
  FOLDER: 'FOLDER',
  REJECTED: 'REJECTED',
  NESL_ERRORS: 'NESL_ERRORS',
};

const DocumentTypeToFolderTypeMap = {
  [DocumentTypes.ACTION_REQUIRED]: 'action_required',
  [DocumentTypes.EXPIRED]: 'expired',
  [DocumentTypes.COMPLETED]: 'completed',
  [DocumentTypes.EXPIRING_SOON]: 'expiring_soon',
  [DocumentTypes.WAITING_FOR_OTHERS]: 'waiting_for_others',
  [DocumentTypes.FAILED]: 'failed',
  [DocumentTypes.SENT]: 'sent',
  [DocumentTypes.RECEIVED]: 'received',
  [DocumentTypes.PROCESSING]: 'processing',
  [DocumentTypes.CC]: 'cc',
  [DocumentTypes.DRAFTS]: 'drafts',
  [DocumentTypes.REJECTED]: 'rejected',
};

const URLByDocumentTypes = {
  [DocumentTypes.SENT]: routeUrls.documentsSent,
  [DocumentTypes.RECEIVED]: routeUrls.documentsReceived,
  [DocumentTypes.PROCESSING]: routeUrls.documentsProcessing,
};
const LabelByDocumentTypes = {
  [DocumentTypes.RECEIVED]: 'RECEIVED',
  [DocumentTypes.SENT]: 'SENT',
};

const HeaderTextByType = {
  [DocumentTypes.ACTION_REQUIRED]: 'ACTION_REQUIRED',
  [DocumentTypes.EXPIRED]: 'EXPIRED',
  [DocumentTypes.COMPLETED]: 'COMPLETED',
  [DocumentTypes.EXPIRING_SOON]: 'EXPIRING_SOON',
  [DocumentTypes.WAITING_FOR_OTHERS]: 'WAITING_FOR_OTHERS',
  [DocumentTypes.FAILED]: 'FAILED',
  [DocumentTypes.SENT]: 'SENT',
  [DocumentTypes.RECEIVED]: 'RECEIVED_INVITATIONS',
  [DocumentTypes.PROCESSING]: 'PROCESSING',
  [DocumentTypes.ALL]: 'ALL',
  [DocumentTypes.CC]: 'CC',
  [DocumentTypes.DRAFTS]: 'DRAFTS',
  [DocumentTypes.REJECTED]: 'REJECTED_INVITATION',
  [DocumentTypes.NESL_ERRORS]: 'NESL_ERRORS',
};

const SupportTextByType = {
  [DocumentTypes.ACTION_REQUIRED]: 'SENT_DOCUMENTS_DESCRIPTION',
  [DocumentTypes.EXPIRED]: 'SENT_DOCUMENTS_DESCRIPTION',
  [DocumentTypes.COMPLETED]: 'SENT_DOCUMENTS_DESCRIPTION',
  [DocumentTypes.EXPIRING_SOON]: 'SENT_DOCUMENTS_DESCRIPTION',
  [DocumentTypes.WAITING_FOR_OTHERS]: 'SENT_DOCUMENTS_DESCRIPTION',
  [DocumentTypes.FAILED]: 'SENT_DOCUMENTS_DESCRIPTION',
  [DocumentTypes.SENT]: '',
  [DocumentTypes.RECEIVED]: '',
  [DocumentTypes.PROCESSING]: '',
  [DocumentTypes.ALL]: 'SENT_DOCUMENTS_DESCRIPTION',
  [DocumentTypes.CC]: '',
  [DocumentTypes.DRAFTS]: 'SENT_DOCUMENTS_DESCRIPTION',
  [DocumentTypes.REJECTED]: 'REJECTED_INVITATION',
  [DocumentTypes.NESL_ERRORS]: '',

};

const BulkSignType = 'bulkSigning';
const FiltersDisabled = [
  DocumentTypes.CC, DocumentTypes.FOLDER, DocumentTypes.PROCESSING, DocumentTypes.NESL_ERRORS,
];
const NESL_ESIGN_TYPE = 'NESL_ESIGN';
const DefaultPagination = {
  page: 1,
  limit: 10,
};

export {
  DocumentTypes,
  URLByDocumentTypes,
  HeaderTextByType,
  LabelByDocumentTypes,
  SupportTextByType,
  DocumentTypeToFolderTypeMap,
  BulkSignType,
  FiltersDisabled,
  DefaultPagination,
  NESL_ESIGN_TYPE,
};
